import { Avatar, Button, Stack, Typography } from '@mui/material';
import { AppliesContext } from 'Context/AppliesContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowRightWhite } from 'Images';
import { useContext } from 'react';

interface IActionButtons {
  closeAdvancedSearch: () => void;
}

export const ActionButtons = ({ closeAdvancedSearch }: IActionButtons) => {
  const {
    filterApplications,
    resetFiltersAndFilteredApplications,
    filtersData,
  } = useContext(AppliesContext);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Applies);
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      justifyContent={isDesktop ? 'flex-end' : 'space-between'}
      gap={isDesktop ? '64px' : undefined}
    >
      <Button
        variant='textBtn'
        onClick={resetFiltersAndFilteredApplications}
        sx={{
          width: 'fit-content',
          textUnderlineOffset: '3px',
        }}
        aria-label={dictionary.ariaLabelRest}
      >
        <Typography
          fontWeight={700}
          color={'primary.main'}
          fontSize={isDesktop ? '20px' : '18px'}
        >
          {dictionary.clear}
        </Typography>
      </Button>
      <Button
        sx={{
          width: isDesktop ? '176px' : '162px',
          bgcolor: 'primary.shade_400',
          boxShadow: '0px 2px 10px rgba(4, 16, 46, 0.06)',
          borderRadius: '100px',
          padding: isDesktop ? '12px 24px' : '10px 24px',
          gap: '4px',
          ':hover': { cursor: 'pointer', bgcolor: 'primary.shade_400' },
        }}
        onClick={() => {
          filterApplications(filtersData);
          closeAdvancedSearch();
        }}
      >
        <Typography variant={'body4'} color={'#fff'}>
          {dictionary.showResults}
        </Typography>
        <Avatar src={ArrowRightWhite} sx={{ width: '20px', height: '20px' }} />
      </Button>
    </Stack>
  );
};
